
import React, { createContext, useReducer, useContext, useEffect } from "react";
const CartContext = createContext();
const cartReducer = (state, action) => {
  switch (action.type) {
    case "ADD_ITEM":
      return {
        ...state,
        [action.payload.tabId]: {
          ...state[action.payload.tabId],
          items: action.payload.item
            ? Array.isArray(state[action.payload.tabId]?.items)
              ? [...state[action.payload.tabId].items, action.payload.item]
              : [action.payload.item]
            : state[action.payload.tabId]?.items,
          customerDetail: action.payload.customerDetail
            ? [
              ...(state[action.payload.tabId]?.customerDetail || []),
              action.payload.customerDetail,
            ]
            : state[action.payload.tabId]?.customerDetail,
            customerLevel:
            action.payload.customerLevel ??
            state[action.payload.tabId]?.customerLevel ??
            "ทั่วไป",
    
        },
      };

    case "UPDATE_ITEM":
      return {
        ...state,
        [action.payload.tabId]: {
          ...state[action.payload.tabId],
          items: state[action.payload.tabId].items.map((item) =>
            item.id === action.payload.item.id
              ? { ...item, ...action.payload.item }
              : item
          ),
        },
      };
    case "REMOVE_ITEM":
      return {
        ...state,
        [action.payload.tabId]: {
          ...state[action.payload.tabId], // คัดลอกข้อมูลเดิมของ tabId
          items: state[action.payload.tabId].items.filter(
            (item) => item.id !== action.payload.id
          ), // ลบ item ที่มี id ตรงกับ action.payload.id
        },
      };

    // case "ADD_ITEM":
    //   return {
    //     ...state,
    //     [action.payload.tabId]: Array.isArray(state[action.payload.tabId])
    //       ? [...state[action.payload.tabId], action.payload.item]
    //       : [action.payload.item],
    //   };
    // case "UPDATE_ITEM":
    //   return {
    //     ...state,
    //     [action.payload.tabId]: state[action.payload.tabId].map((item) =>
    //       item.id === action.payload.item.id
    //         ? { ...item, ...action.payload.item }
    //         : item
    //     ),
    //   };
    // case "REMOVE_ITEM":
    //   return {
    //     ...state,
    //     [action.payload.tabId]: state[action.payload.tabId].filter(
    //       (item) => item.id !== action.payload.id
    //     ),
    //   };
    case "REMOVE_CUSTOMER_DETAIL":
      return {
        ...state,
        [action.payload.tabId]: {
          ...state[action.payload.tabId],
          customerDetail:
            Object.keys(action.payload.customerDetail).length === 0
              ? undefined
              : state[action.payload.tabId].customerDetail.filter(
                (customer) => customer.id !== action.payload.customerId
              ),
        },
      };

    case "CLEAR_CART":
      return {
        ...state,
        [action.payload.tabId]: [],
      };
    default:
      return state;
  }
};

// สร้าง context provider
export const CartProvider = ({ children }) => {
  const initialCart = JSON.parse(localStorage.getItem("cart")) || [];
  const [cart, dispatch] = useReducer(cartReducer, initialCart);
  const filteredCart = Object.fromEntries(
    Object.entries(cart).filter(([_, value]) => !(Array.isArray(value) && value.length === 0))
  );
  console.log('filteredCart', filteredCart)
  useEffect(() => {
    localStorage.setItem("cart", JSON.stringify(filteredCart));
  }, [cart]);

  return (
    <CartContext.Provider value={{ cart, dispatch }}>
      {children}
    </CartContext.Provider>
  );
};

export const useCart = () => useContext(CartContext);
